import * as actionTypes from '../Register_action.types';

const initialState = {
  loggingIn: false,
  leave_register: [],
  error: null,
  message: '',
};

const leaveRegisterReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_LEAVE_REGISTER_REQUEST:
    case actionTypes.DELETE_LEAVE_REGISTER_REQUEST:
    case actionTypes.UPLOAD_LEAVE_REGISTER_REQUEST:
    case actionTypes.MULTIDELETE_LEAVE_REGISTER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.UPDATE_LEAVE_REGISTER_SUCCESS:
    case actionTypes.DELETE_LEAVE_REGISTER_SUCCESS:
    case actionTypes.UPLOAD_LEAVE_REGISTER_SUCCESS:
    case actionTypes.MULTIDELETE_LEAVE_REGISTER_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
      };
    case actionTypes.GET_LEAVE_REGISTER_SUCCESS:
      return {
        ...state,
        loading: false,
        leaves_register: action.payload,

      }
    case actionTypes.GET_LEAVE_REGISTER_FAILURE:
    case actionTypes.UPDATE_LEAVE_REGISTER_FAILURE:
    case actionTypes.DELETE_LEAVE_REGISTER_FAILURE:
    case actionTypes.UPLOAD_LEAVE_REGISTER_FAILURE:
    case actionTypes.MULTIDELETE_LEAVE_REGISTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default leaveRegisterReducer
